import React from 'react';

interface PropertySelectProps {
  label: string;
  value: string;
  options: { value: string; label: string }[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const PropertySelect: React.FC<PropertySelectProps> = ({
  label,
  value,
  options,
  onChange,
  disabled = false
}) => {
  return (
    <div className="flex flex-1 items-center gap-1.5">
      <label className="text-gray-600 dark:text-gray-400 text-sm font-medium w-4 flex-shrink-0">
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full bg-white dark:bg-gray-900 text-gray-900 dark:text-white text-sm px-2 py-1.5 rounded border border-gray-300 dark:border-gray-600 focus:border-primary-500 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};


